import { useState } from 'react';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import SeasonsList from './SeasonsList';
import ClawMachinePrizes from '../ClawMachine';
import ClawCoinsList from './clawCoins';


const Seasons = () => {
    const [tabIndex, setTabIndex] = useState<number>(0);

    return (
        <>
            <Tabs
                index={tabIndex}
                onChange={setTabIndex}
            >
                <TabList
                    margin='0 20px 0px 20px'
                    borderColor='#343847'
                    position='relative'
                    sx={{
                        '&::-webkit-scrollbar': {
                            display: 'none !important'
                        },
                        overflowX: 'auto !important',
                        overflowY: 'hidden !important',
                    }}
                >
                    <Tab color="white" whiteSpace='nowrap' paddingBottom='4px' _selected={{ fontWeight: '800', borderBottom: '4px solid white', paddingBottom: '2px' }} fontWeight='600'>
                        Temporadas
                    </Tab>
                    <Tab color="white" whiteSpace='nowrap' paddingBottom='4px' _selected={{ fontWeight: '800', borderBottom: '4px solid white', paddingBottom: '2px' }} fontWeight='600'>
                        Premios Máquina de Garra
                    </Tab>
                    <Tab color="white" whiteSpace='nowrap' paddingBottom='4px' _selected={{ fontWeight: '800', borderBottom: '4px solid white', paddingBottom: '2px' }} fontWeight='600'>
                        Monedas Máquina de Garra
                    </Tab>
                </TabList>

                <TabPanels p='0'>
                    <TabPanel p='0'>
                        <SeasonsList />
                    </TabPanel>
                    <TabPanel p='0'>
                        <ClawMachinePrizes />
                    </TabPanel>
                    <TabPanel p='0'>
                        <ClawCoinsList />
                    </TabPanel>
                </TabPanels>
            </Tabs>

        </>
    );
}

export default Seasons;